// LeaderboardCategory.js
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import LeaderboardCategory from '../page/LeaderboardCategory.jsx';
import { replace } from '../action/navigationAction.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getOperationData from '../selector/getOperationData.js';
import {
  LEADERBOARD_CATEGORIES,
  LEADERBOARD_IDS,
  PUBLIC_LEADERBOARD_URL_PATH,
} from '../RemoteConfigKeys.js';

const mapStateToProps = state => {
  const categories = getRemoteConfigData(state, LEADERBOARD_CATEGORIES);
  const regions = getRemoteConfigData(state, LEADERBOARD_IDS);
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const publicLeaderboardUrlPath = getRemoteConfigData(
    state,
    PUBLIC_LEADERBOARD_URL_PATH
  );

  return {
    categories,
    regions,
    deviceWidth,
    publicLeaderboardUrlPath,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    replace: ({ pathname }) => dispatch(replace(pathname)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaderboardCategory);
